export default () => ({
  history: {},
  categories: [],
  protocolsResult: [],
  currentProtocol: undefined,
  loading: false,
  sentToChannels: false,
  navigationHistory: undefined
})
